import { fetch } from '@/shared/fetch';
import { NewbornProgram } from '@/features/programs/model/types';

export const getNewbornProgram = async (): Promise<NewbornProgram> => {
    return await fetch<NewbornProgram>('/api/newborn/program', 'GET');
};
